var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("th", [_vm._v(_vm._s(_vm.$t(_vm.title)))]),
    _vm._v(" "),
    _c(
      "td",
      { staticClass: "right input-cell" },
      [
        _c("ValidationProvider", {
          attrs: { rules: "min_value:0", slim: "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var errors = ref.errors
                var failedRules = ref.failedRules
                return [
                  _c("numeric-input-control", {
                    attrs: {
                      disabled: _vm.isReadOnly,
                      placeholderKey: "EnterValue",
                      labelledBy: _vm.labelledBy + "_1"
                    },
                    model: {
                      value: _vm.row.ages0to6,
                      callback: function($$v) {
                        _vm.$set(_vm.row, "ages0to6", $$v)
                      },
                      expression: "row.ages0to6"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      { staticClass: "right input-cell" },
      [
        _c("ValidationProvider", {
          attrs: { rules: "min_value:0", slim: "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var errors = ref.errors
                var failedRules = ref.failedRules
                return [
                  _c("numeric-input-control", {
                    attrs: {
                      disabled: _vm.isReadOnly,
                      placeholderKey: "EnterValue",
                      labelledBy: _vm.labelledBy + "_2"
                    },
                    model: {
                      value: _vm.row.ages7to17,
                      callback: function($$v) {
                        _vm.$set(_vm.row, "ages7to17", $$v)
                      },
                      expression: "row.ages7to17"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      { staticClass: "right input-cell" },
      [
        _c("ValidationProvider", {
          attrs: { rules: "min_value:0", slim: "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var errors = ref.errors
                var failedRules = ref.failedRules
                return [
                  _c("numeric-input-control", {
                    attrs: {
                      disabled: _vm.isReadOnly,
                      placeholderKey: "EnterValue",
                      labelledBy: _vm.labelledBy + "_3"
                    },
                    model: {
                      value: _vm.row.ages18to29,
                      callback: function($$v) {
                        _vm.$set(_vm.row, "ages18to29", $$v)
                      },
                      expression: "row.ages18to29"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      { staticClass: "right input-cell" },
      [
        _c("ValidationProvider", {
          attrs: { rules: "min_value:0", slim: "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var errors = ref.errors
                var failedRules = ref.failedRules
                return [
                  _c("numeric-input-control", {
                    attrs: {
                      disabled: _vm.isReadOnly,
                      placeholderKey: "EnterValue",
                      labelledBy: _vm.labelledBy + "_4"
                    },
                    model: {
                      value: _vm.row.ages30to62,
                      callback: function($$v) {
                        _vm.$set(_vm.row, "ages30to62", $$v)
                      },
                      expression: "row.ages30to62"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      { staticClass: "right input-cell" },
      [
        _c("ValidationProvider", {
          attrs: { rules: "min_value:0", slim: "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var errors = ref.errors
                var failedRules = ref.failedRules
                return [
                  _c("numeric-input-control", {
                    attrs: {
                      disabled: _vm.isReadOnly,
                      placeholderKey: "EnterValue",
                      labelledBy: _vm.labelledBy + "_5"
                    },
                    model: {
                      value: _vm.row.ages63to79,
                      callback: function($$v) {
                        _vm.$set(_vm.row, "ages63to79", $$v)
                      },
                      expression: "row.ages63to79"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "td",
      { staticClass: "right input-cell" },
      [
        _c("ValidationProvider", {
          attrs: { rules: "min_value:0", slim: "" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var errors = ref.errors
                var failedRules = ref.failedRules
                return [
                  _c("numeric-input-control", {
                    attrs: {
                      disabled: _vm.isReadOnly,
                      placeholderKey: "EnterValue",
                      labelledBy: _vm.labelledBy + "_6"
                    },
                    model: {
                      value: _vm.row.ages80plus,
                      callback: function($$v) {
                        _vm.$set(_vm.row, "ages80plus", $$v)
                      },
                      expression: "row.ages80plus"
                    }
                  })
                ]
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("td", { staticClass: "right disabled-background" }, [
      _c("b", [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.rowSum)))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }